module.exports = "/dist/assets/images/arrow-right.svg";